import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './GallerySectionGridLayout.css';

export interface IGallerySectionGridLayoutProps {
  children: React.ReactNode[];
}

export const GallerySectionGridLayout: React.FC<IGallerySectionGridLayoutProps> = props => {
  const { children } = props;

  return <div className={clsx(styles['grid'], styles[`grid-size-${children.length}`])}>{children}</div>;
};
